var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { deferred } from 'fast-defer';
import { Header } from '../util/headers';
var CacheRequestInterceptor = /** @class */ (function () {
    function CacheRequestInterceptor(axios) {
        var _this = this;
        this.axios = axios;
        this.use = function () {
            _this.axios.interceptors.request.use(_this.onFulfilled);
        };
        this.onFulfilled = function (config) { return __awaiter(_this, void 0, void 0, function () {
            var key, cache, cachedResponse, deferred_1, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (config.cache === false) {
                            return [2 /*return*/, config];
                        }
                        // merge defaults with per request configuration
                        config.cache = __assign(__assign({}, this.axios.defaults.cache), config.cache);
                        if (
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        !CacheRequestInterceptor.isMethodAllowed(config.method, config.cache)) {
                            return [2 /*return*/, config];
                        }
                        key = this.axios.generateKey(config);
                        return [4 /*yield*/, this.axios.storage.get(key)];
                    case 1:
                        cache = _c.sent();
                        if (!(cache.state == 'empty' || cache.state === 'stale')) return [3 /*break*/, 5];
                        if (!this.axios.waiting[key]) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.axios.storage.get(key)];
                    case 2:
                        cache = (_c.sent());
                        return [3 /*break*/, 5];
                    case 3:
                        // Create a deferred to resolve other requests for the same key when it's completed
                        this.axios.waiting[key] = deferred();
                        /**
                         * Add a default reject handler to catch when the request is aborted without others
                         * waiting for it.
                         */
                        (_b = this.axios.waiting[key]) === null || _b === void 0 ? void 0 : _b.catch(function () { return undefined; });
                        return [4 /*yield*/, this.axios.storage.set(key, {
                                state: 'loading',
                                data: cache.data
                            })];
                    case 4:
                        _c.sent();
                        if (cache.state === 'stale') {
                            //@ts-expect-error type infer couldn't resolve this
                            CacheRequestInterceptor.setRevalidationHeaders(cache, config);
                        }
                        config.validateStatus = CacheRequestInterceptor.createValidateStatus(config.validateStatus);
                        return [2 /*return*/, config];
                    case 5:
                        if (!(cache.state === 'loading')) return [3 /*break*/, 11];
                        deferred_1 = this.axios.waiting[key];
                        if (!!deferred_1) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.axios.storage.remove(key)];
                    case 6:
                        _c.sent();
                        return [2 /*return*/, config];
                    case 7:
                        _c.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, deferred_1];
                    case 8:
                        cachedResponse = _c.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        _a = _c.sent();
                        // The deferred is rejected when the request that we are waiting rejected cache.
                        return [2 /*return*/, config];
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        cachedResponse = cache.data;
                        _c.label = 12;
                    case 12:
                        config.adapter = function () {
                            /**
                             * Even though the response interceptor receives this one from here, it has been
                             * configured to ignore cached responses: true
                             */
                            return Promise.resolve({
                                config: config,
                                data: cachedResponse.data,
                                headers: cachedResponse.headers,
                                status: cachedResponse.status,
                                statusText: cachedResponse.statusText,
                                cached: true,
                                id: key
                            });
                        };
                        return [2 /*return*/, config];
                }
            });
        }); };
    }
    CacheRequestInterceptor.isMethodAllowed = function (method, properties) {
        var e_1, _a;
        var requestMethod = method.toLowerCase();
        try {
            for (var _b = __values(properties.methods || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                var method_1 = _c.value;
                if (method_1.toLowerCase() === requestMethod) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    CacheRequestInterceptor.setRevalidationHeaders = function (cache, config) {
        var _a;
        config.headers || (config.headers = {});
        var _b = config.cache, etag = _b.etag, modifiedSince = _b.modifiedSince;
        if (etag) {
            var etagValue = etag === true ? (_a = cache.data) === null || _a === void 0 ? void 0 : _a.headers[Header.ETag] : etag;
            if (etagValue) {
                config.headers[Header.IfNoneMatch] = etagValue;
            }
        }
        if (modifiedSince) {
            config.headers[Header.IfModifiedSince] =
                modifiedSince === true
                    ? // If last-modified is not present, use the createdAt timestamp
                        cache.data.headers[Header.LastModified] ||
                            new Date(cache.createdAt).toUTCString()
                    : modifiedSince.toUTCString();
        }
    };
    /**
     * Creates a new validateStatus function that will use the one already used and also
     * accept status code 304.
     */
    CacheRequestInterceptor.createValidateStatus = function (oldValidate) {
        return function (status) {
            return oldValidate
                ? oldValidate(status) || status === 304
                : (status >= 200 && status < 300) || status === 304;
        };
    };
    return CacheRequestInterceptor;
}());
export { CacheRequestInterceptor };
